import { hubForPage, useLayout } from '../layout';
import { WidgetView } from './Widgets';

/** Widgets van de hub die in de editor aan deze pagina is gekoppeld (bovenaan de pagina). */
export function PageHub({ page }: { page: string }) {
  const layout = useLayout();
  const hub = hubForPage(layout, page);
  const widgets = hub?.widgets.filter((w) => w.enabled) ?? [];
  if (!widgets.length) return null;
  return (
    <div className={`lib-hub page-hub ${['spotlight', 'billboard'].includes(widgets[0].view) ? 'with-spotlight' : ''}`} aria-label={`Hub ${hub!.name}`}>
      {widgets.map((w) => <WidgetView key={w.id} w={w} />)}
    </div>
  );
}
